// Move to Sanity when theres time

export const translations: Record<string, Record<string, string>> = {
  se: {
    shop: "Butik",
    helpSupport: "Hjälp & Support",
    company: "Företag",
    connect: "Anslut",
    exploreLinkLabel: "Galleriet",
    latestLinkLabel: "Senaste nytt",
    popularLinkLabel: "Mest sålda",
    aboutLinkLabel: "Om oss",
    termsLinkLabel: "Villkor",
    privacyLinkLabel: "Integritetspolicy",
    contactLinkLabel: "Kontakt",
    faqLinkLabel: "FAQ",
    joinArtistLabel: "Bli en del av oss som posterdesigner",
    instagramLabel: "Instagram",
    allRightsReserved: "Alla rättigheter förbehållna",
    noEmailNoGoodieLabel: `No email, no goodies. Don't miss out on the treats!`,
    welcomeToCommunityLabel: "Välkomen till komunitiet",
    newsletterEmailLabel: "you@example.com",
    newsletterButtonLabel: "Prenumerera",
    newsletterLabel: "Anmäl dig till vårt Nyhetsbrev",
    shopLinkLabel: "Butik",
    helpLinkLabel: "Hjälp & Support",
    companyLinkLabel: "Företag",
    connectLinkLabel: "NordicPosterStore",
  },
  us: {
    shop: "Shop",
    helpSupport: "Help & Support",
    company: "Company",
    connect: "Connect",
    exploreLinkLabel: "Explore",
    latestLinkLabel: "Latest",
    popularLinkLabel: "Popular",
    aboutLinkLabel: "About Us",
    termsLinkLabel: "Terms & Conditions",
    privacyLinkLabel: "Privacy Policy",
    contactLinkLabel: "Contact",
    faqLinkLabel: "FAQ",
    joinArtistLabel: "Join us as an artist",
    instagramLabel: "Instagram",
    allRightsReserved: "All Rights Reserved",
    noEmailNoGoodieLabel: `No email, no goodies. Don't miss out on the treats!`,
    welcomeToCommunityLabel: "Welcome to the community",
    newsletterEmailLabel: "you@example.com",
    newsletterButtonLabel: "Subscribe",
    newsletterLabel: "Sign up to our newsletter & join our community",
    shopLinkLabel: "Shop",
    helpLinkLabel: "Help & Support",
    companyLinkLabel: "Company",
    connectLinkLabel: "Connect",
  },
};
